(function(){
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsController', TabActionsController);

    TabActionsController.$inject = ['pagingParams', '$state', 'TabActions', 'ParseLinks', 'AlertService'];

    function TabActionsController (pagingParams, $state, TabActions, ParseLinks, AlertService) {
        var vm = this;
        vm.tabActions = [];
        vm.predicates = {};
        vm.page = 0;
        vm.charToSearch = pagingParams.search;
        vm.currentState = "tab-actions";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function() {

            var page = {
                page: vm.page,
                size: 20,
                sort: sort()
            };
            var ch = {ch: vm.charToSearch};
            TabActions.search(page,ch, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabActions.push(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last'])
                    vm.loadPage(vm.page + 1);

                transition ();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        vm.reset = function() {
            vm.page = 0;
            vm.tabActions = [];
            vm.loadAll();
        };
        vm.loadPage = function(page) {
            vm.page = page;
            vm.loadAll();
        };

        vm.loadAll();

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.charToSearch
            }, {notify: false, location: "replace"});
        }

        vm.search = function () {
            vm.tabActions = [];
            vm.page = 0;
            vm.loadAll();
        };

    }
})();
